module.exports = __webpack_public_path__ + "img/search.2b3f1e84.png";